import SubPageLayout, { SubPageCta, SubPageHero, SubPageLoading } from "@/components/public/SubPageLayout";
import { DietaryCard, ExtrasCard, FlavoursCard, PriceTable } from "@/components/public/PriceCards";
import { useSiteContent } from "@/lib/content";

export default function Prices() {
  const content = useSiteContent();
  if (!content) return <SubPageLoading testId="prices-loading" />;
  const p = content.prices;

  return (
    <SubPageLayout prefix="prices" pageTestId="prices-page">
      <SubPageHero
        prefix="prices"
        eyebrow="Sweet treats, honest prices"
        heading="Cupcake Prices"
        disclaimer={
          <>
            <strong className="text-burgundy">Please note: all prices are a guide only.</strong> Your final price will likely change based on your
            design ideas — themes, colours, toppers, flavours and finishes. Don’t see what you’re after, or would you like a custom quote? Send me a
            message and I’ll help you out.
          </>
        }
      />

      <div className="mt-12 grid items-start gap-8 lg:grid-cols-[1fr_1.4fr]">
        <PriceTable title="Mini Cupcakes" rows={p.mini} testId="mini-prices" />
        <PriceTable title="Regular Cupcakes" rows={p.regular} testId="regular-prices" />
      </div>

      <div className="mt-8 grid items-start gap-8 lg:grid-cols-2">
        <ExtrasCard extras={p.extras} />
        <div className="space-y-8">
          <FlavoursCard flavours={p.flavours} premium={p.premium_flavours} premiumNote={p.premium_note} />
          <DietaryCard dietary={p.dietary} />
        </div>
      </div>

      <SubPageCta prefix="prices" script="Don’t see what you’re after?" label="Request a Custom Quote" />
    </SubPageLayout>
  );
}
